<template>
  <div class="home-box">
    <template v-for="(section, index) in list">
      <NvSection :section="section" :key="index" />
    </template>
    <img class="banner" :src="bannerImage" alt="novelover banner" />
  </div>
</template>

<script>
import NvSection from "@/components/layout/NvSection";
import { getBookList } from "@/service/api";
import bannerImage from "@/assets/banner.png";

export default {
  name: "BookDiscover",
  components: {
    NvSection
  },
  data() {
    return {
      show: false,
      list: [],
      bannerImage
    };
  },
  methods: {
    getList() {
      getBookList().then(res => {
        this.list = res || [];
      });
    }
  },
  activated() {
    this.getList();
    window.$event("Main_BookCity_Show", {});
  }
};
</script>

<style lang="scss" scoped>
.home-box {
  .banner {
    width: 100%;
    height: 70px;
    margin-bottom: 50px;
  }
}
</style>
